module.exports = __webpack_public_path__ + "img/Delete.7de557e9.svg";